import React from 'react';
import { Link } from 'react-router-dom';
import Helpers from '@Apis/helpers';
import {
  Popover, Space, Tag, Tooltip,
} from 'antd';
import dayjs from 'dayjs';
import PRZText from '../../../Common/UI/PRZText';

const ListScreenKeys = ({
  documentData, user,
}) => {
  const record = documentData;

  const colorArray = ['blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple', 'blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple'];

  const so = () => {
    let content = '-';

    if (Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user)) {
      if (record?.order_type !== 'PACKING_SLIP') {
        // Check if the record has an order ID
        if (record?.order_id) {
          content = (
            <Link
            // to={`/sales/sales-order/view/${record?.order_id}`} target="_blank"
            >
              {record?.sales_order_number}
            </Link>
          );
        }
      }
    }
    return (
      <div>
        <div className="associated-entity">
          {content}
        </div>
        <div className="associated-entity">
          {Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN,
            Helpers.permissionTypes.READ, user)
            ? (
              <React.Fragment>
                {record?.delivery_challan_id ? (
                  <Link
                  //  to={`/inventory/delivery-challan/view/${record?.delivery_challan_id}`} 
                  //  target="_blank"
                  >
                    {record?.dc_number}
                  </Link>
                ) : ''}
              </React.Fragment>
            ) : (record?.order_id || '')}
        </div>
      </div>
    );
  };

  const ps = () => {
    let content = '-';
    if (Helpers.getPermission(Helpers.permissionEntities.PACKING_SLIP, Helpers.permissionTypes.READ, user)) {
      if (record?.order_type === 'PACKING_SLIP') {
        if (record?.order_id) {
          content = (
            <Link to={`/sales/packing-slip/view/${record?.order_id}`} target="_blank">
              {record?.sales_order_number}
            </Link>
          );
        }
      }
    }
    return (
      <div>
        <div className="associated-entity">
          {content}
        </div>
      </div>
    );
  };

  const gateDocumentNumber = () => {
    const gateDocNumber = record?.ref_gate_document;

    if (!gateDocNumber) return '-';

    const otherDocs = (
      <div>
        {
          gateDocNumber?.slice(2).map((document, i) => (
            <div className="other-uom-stock" key={i}>
              <div
              // onClick={() => window.open(`/logistic/gate-document/view/${document?.gate_document_id}`)}
              >
                {document?.gate_document_number}
              </div>
            </div>
          ))
        }
      </div>
    );
    return (
      <Popover
        placement="bottom"
        content={gateDocNumber?.length > 2 && otherDocs}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
      >
        <div style={{
          fontWeight: 600,
          color: '#1890FF',
        }}
        >
          {gateDocNumber?.slice(0, 2)?.map((document) => (
            <Link
              // to={`/logistic/gate-document/view/${document?.gate_document_id}`}
              // target="_blank"
              key={document?.gate_document_id}
            >
              <PRZText text={document?.gate_document_number} />
            </Link>
          ))}
          {document?.length > 2 && (
            <PRZText
              className="table-subscript-grey"
              text={`and ${document.length - 2} more`}
            />
          )}
        </div>
      </Popover>
    );
  };

  return [
    {
      label: 'Shopify #',
      value: (user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.shopify_location_id && record?.shopify_order_id
      )
        ? (
          <Tooltip
            title={`Order placed on ${dayjs(record?.shopify_created_at).format('DD/MM/YYYY hh:mm A')}`}
            overlayClassName="font-12"
            placement="topRight"
          >
            <a
            // href={`https://admin.shopify.com/store/${record?.shopify_shop_name?.split('.')?.[0]}/orders/${record?.shopify_order_id}`}
            // target="_blank"
            // rel="noreferrer"
            >
              {record?.shopify_order_number}
            </a>
          </Tooltip>
        )
        : '-',
    },
    {
      label: 'SO #',
      value: so(),
    },
    {
      label: 'PS #',
      value: ps(),
    },
    {
      label: 'WO #',
      value: Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ, user)
        ? (
          <React.Fragment>
            {record?.subcontractor_po_details?.po_id ? (
              <Link to={`/approval?type=po&id=${record?.subcontractor_po_details?.po_id}`} target="_blank">
                {record?.subcontractor_po_details?.po_number}
              </Link>
            ) : '-'}
          </React.Fragment>
        ) : (record?.subcontractor_po_details?.po_id || '-'),
    },
    {
      label: 'Gate Document Number',
      value: gateDocumentNumber(),
    },
    {
      label: 'Items',
      value: record?.item_count || 0,
    },
    {
      label: 'Created Date',
      value: (
        <React.Fragment>
          <PRZText text={dayjs(record?.created_at).format('DD/MM/YYYY')} />
          <PRZText text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
        </React.Fragment>
      ),
    },
    {
      label: 'Labels',
      value: record?.tags ? (
        <Space size={[0, 2]} wrap>
          {record?.tags?.map((tag, index) => (
            <Tag
              key={index}
              color={colorArray[index]}
              style={{
                fontSize: '11px',
                margin: '0 2px',
              }}
            >
              {tag}
            </Tag>
          ))}
        </Space>
      ) : '-',
    },
  ];
};

export { ListScreenKeys };
